import React from 'react'
import styled from 'styled-components'
import { Button } from 'pcln-design-system'

import { LoadingText } from '../LoadingText'

const StyledLoadMoreButton = styled(Button)`
  display: flex;
  justify-content: center;
  margin: 0 8px;
  width: calc(100% - 16px);
  ${(props) => props.theme.mediaQueries.xl} {
    margin: 0;
    width: 100%;
  }
`

const LoadMoreBtn = ({ onClick, requestPending }) => {
  const handleOnClick = () => {
    if (onClick) {
      onClick()
    }
  }

  return (
    <StyledLoadMoreButton onClick={handleOnClick} size={'large'} disabled={requestPending}>
      {requestPending ? (
        <LoadingText color='background.lightest' />
      ) : (
        <span data-testid={'view-more-button'}>View More Flights</span>
      )}
    </StyledLoadMoreButton>
  )
}

export { LoadMoreBtn }
